import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bemComponent from '@99designs/utils/app/bemComponent';

export const Header = bemComponent('fullscreen-header', 'Header');

export class Item extends React.Component {
    render() {
        var classes = classNames({
            'fullscreen-header__item': true,
            'fullscreen-header__item--first': this.props.isFirst,
            'fullscreen-header__item--last': this.props.isLast,
        });

        return <div className={classes}>{this.props.children}</div>;
    }
}

Item.propTypes = {
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
};

Item.defaultProps = {
    isLast: false,
    isFirst: false,
};



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/Header.js